/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLeftFilled: {
  name: 'left-filled';
  data: string;
} = {
  name: 'left-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14.32 4.896a2.07 2.07 0 0 0-.4.14c-.126.065-1.068.981-3.162 3.078C7.327 11.549 7.54 11.291 7.54 12s-.213.451 3.218 3.886c2.35 2.353 3.025 3.008 3.186 3.088.618.307 1.341.188 1.793-.295.336-.359.469-.804.383-1.28-.091-.503-.076-.485-2.613-3.029L11.143 12l2.364-2.37c2.537-2.544 2.522-2.526 2.613-3.029.054-.3.003-.68-.126-.933a1.55 1.55 0 0 0-1.051-.785c-.285-.052-.339-.051-.623.013"/></svg>`
};
